import React from 'react';
import { motion } from 'framer-motion';
import { Users, Stethoscope, Leaf, ShieldCheck } from 'lucide-react';
const trustItems = [{
  icon: <Users className="w-6 h-6" data-id="element-155" />,
  text: '100.000+ zufriedene Kunden'
}, {
  icon: <Stethoscope className="w-6 h-6" data-id="element-156" />,
  text: 'Von Tierärzten empfohlen'
}, {
  icon: <Leaf className="w-6 h-6" data-id="element-157" />,
  text: '100% pflanzlich & natürlich'
}, {
  icon: <ShieldCheck className="w-6 h-6" data-id="element-158" />,
  text: 'Geld-zurück-Garantie'
}];
export function TrustBar() {
  return <section className="w-full bg-forest text-cream py-8 px-4" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4" data-id="element-161">
          {trustItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center gap-3" data-id="element-162">
              <div className="bg-cream/10 p-3 rounded-full" data-id="element-163">{item.icon}</div>
              <span className="font-serif text-sm md:text-base font-medium" data-id="element-164">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}